import { render } from "./SchemeMaster.vue?vue&type=template&id=46d5cd0d&scoped=true"
import script from "./SchemeMaster.vue?vue&type=script&lang=js"
export * from "./SchemeMaster.vue?vue&type=script&lang=js"

import "./SchemeMaster.vue?vue&type=style&index=0&id=46d5cd0d&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Private\\Edukatta_Private_Managment_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46d5cd0d"]])

export default __exports__